import { createContext } from "react";

const ActivitiesContext = createContext();

export default ActivitiesContext;
